import { render, staticRenderFns } from "./SsoRetorno.vue?vue&type=template&id=61631790&scoped=true"
import script from "./SsoRetorno.vue?vue&type=script&lang=js"
export * from "./SsoRetorno.vue?vue&type=script&lang=js"
import style0 from "./SsoRetorno.vue?vue&type=style&index=0&id=61631790&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61631790",
  null
  
)

export default component.exports